module.exports = ".product-content {\n    margin-top: 20px;\n}\n\n.product-content .product-label {\n    font-size: 15px;\n    font-weight: 600;\n    color: #000;\n}\n\n.product-content .btn-add-prod{\n    color: #28a745;\n    cursor: pointer;\n    margin-left: 10px;\n    font-size: 15px;\n}\n\n.product-content .btn-remove-prod{\n    color: red;\n    cursor: pointer;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/companies/company-temporary/company-temporary-create/company-temporary-create.component.css
// module id = ./src/app/views/companies/company-temporary/company-temporary-create/company-temporary-create.component.css
// module chunks = main